import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { getStoredUser } from "../utils/authStorage";

type GuardProps = {
  children: React.ReactElement;
};

export const RequireAuth: React.FC<GuardProps> = ({ children }) => {
  const location = useLocation();
  const user = getStoredUser();

  if (!user) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[RouteGuards] Missing/invalid auth user; redirecting to /login", {
        from: location.pathname,
      });
    }
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export const RedirectIfAuthenticated: React.FC<GuardProps> = ({ children }) => {
  const user = getStoredUser();

  if (user) {
    return <Navigate to="/" replace />;
  }

  return children;
};
